import httpServer from "../axios";
import store from '../../store'
import { baseUrlt, baseUrlx, baseUrlq, baseUrld } from "..";

export default {
  getMenuItems(params) {
    return httpServer('get', `${baseUrlt}api/menu/get`, params);
  },
  getOrgans() {
    // return httpServer('get',`${baseUrlt}api/school/structure/get/${id}`);
    return httpServer('get', `${baseUrlt}api/school/structure/get`);
  },
  getOrgansMy() {
    return httpServer('get', `${baseUrlt}api/school/structure/getMy`);
  },
  //实训老师
  getSxls() {
    return httpServer('get', `${baseUrlt}api/user/sxlslist`);
  },
  //授课老师
  getSkls() {
    return httpServer('get', `${baseUrlt}api/user/sklslist`);
  },
  getTarinMent(params) {
    return httpServer('post', `${baseUrlt}api/training/common/gettraininglist`, params);
  },
  getTarinLog() {
    return httpServer('post', `${baseUrlt}api/class/train/log/list`);
  },
  importExc(params) {
    return httpServer('post', `https://api.xixunyun.com/cli/czxxstru`, params);
  },
  addRoleMenu(params) {
    return httpServer('post', `${baseUrlt}api/menu/admin/create`, params);
  },
  updateRoleMenu(id, params) {
    return httpServer('post', `${baseUrlt}api/menu/admin/update/${id}`, params);
  },
  queryRoleMenu(params) {
    return httpServer('get', `${baseUrlt}api/menu/admin/get/${params.role}`);
  },
  getSchools() {
    return httpServer('get', `${baseUrlt}api/school/list/all`, {}, { isLoadd: false })
  },
  getSignature(params) {
    return httpServer('post', `https://api.qxiaoyun.com/wechat/ticket`, params, { isLoadd: false })
  },
  getSignature1() {
    return httpServer('post', `https://api.xixunyun.com/wechat/getwxtoken`, {}, { isLoadd: false })
  },
  addTreeNode(params) {
    return httpServer('post', `${baseUrlt}api/school/structure/add`, params);
  },
  editTreeNode(params) {
    return httpServer('post', `${baseUrlt}api/school/structure/edit`, params);
  },
  getTypeItems(params) {
    return httpServer('get', `${baseUrlt}api/grade/index`, params);
  },
  getTrainSchools() {
    return httpServer('get', `${baseUrlt}api/school/list`, {}, { isLoadd: false })
  },
  getTrainItems() {
    return httpServer('get', `${baseUrlt}api/training_plan/planScoreItemList`)
  },
  getConsumedItems(params) {
    return httpServer('get', `${baseUrlt}api/training_plan/consumedList`, params)
  },
  getNewMessages(params) {
    return httpServer('get', `${baseUrlt}api/message/newMsg`, params, { isLoadd: false })
  },
  getXixunSchools() {
    return httpServer('get', `${baseUrlt}api/school/listqsy`, {}, { isLoadd: false })
  },
  getFunds() {
    return httpServer('get', `${baseUrlt}api/xmhy/training_room/funds/types`)
  },
  getLogoInfo() {
    return httpServer('get', `${baseUrlt}api/login/info`)
  },
  getParams() {
    return httpServer('get', `${baseUrlt}api/training/room/filter/param`)
  },
  getMajor(params) {
    return httpServer('get', `${baseUrlt}api/school/structure/getMajor`, params)
  },
  interfaceServer(url, method, params = {},config) {
    return httpServer(method, `${baseUrlt + url}`, params,config);
  },
  interfaceDcwjServer(url, method, params = {}) {
    // return httpServer(method,`${baseUrld+url}?token=${store.state.userInfo.userToken}`,params);
    return httpServer(method, `${baseUrld + url}`, params);
  }
};